import React from "react";
import SeoHead from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { HotTakeBand } from "./HotTakeBand";
import { Hero, Statement, EmployerProof, HelpSection, ToolsBand, HowItWorks, StrategyBand, ReviewsSection, TeamSection, MathSection, FaqSection, FinalCta, HOME_FAQS } from "./sections";
import COPY from "./content/siteCopy.json";

// Homepage — section order and copy from source/latest/index.html (Site v6). Title/meta = broker's current ranking tags.
export default function HomePage() {
  return (
    <SiteLayout>
      <SeoHead title={COPY.home.title} description={COPY.home.description} path="/" />
      <Hero eyebrow={COPY.home.hero_eyebrow} text={COPY.home.hero_text} />
      <Statement />
      <EmployerProof />
      <HelpSection />
      <ToolsBand />
      <HowItWorks />
      <StrategyBand heading={COPY.home.strategy_heading} />
      <ReviewsSection />
      <TeamSection />
      <HotTakeBand />
      <MathSection />
      <FaqSection items={HOME_FAQS} />
      <FinalCta />
    </SiteLayout>
  );
}
